import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "released", "unreleased"]

  connect() {
    this.updateFromHidden()
  }

  updateFromHidden() {
    if (this.releasedTarget.value === 'true') {
      this.selectTarget.value = 'released'
    } else if (this.unreleasedTarget.value === 'true') {
      this.selectTarget.value = 'unreleased'
    } else {
      this.selectTarget.value = ''
    }
  }

  change() {
    const value = this.selectTarget.value

    if (value === 'released') {
      this.releasedTarget.value = 'true'
      this.unreleasedTarget.value = ''
    } else if (value === 'unreleased') {
      this.releasedTarget.value = ''
      this.unreleasedTarget.value = 'true'
    } else {
      this.releasedTarget.value = ''
      this.unreleasedTarget.value = ''
    }
  }
}
